import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface AffiliateDisclosureProps {
  className?: string;
  /** Optional override for which partners are named at this placement. */
  partners?: string;
}

/**
 * Point-of-click affiliate disclosure.
 *
 * Render this directly beneath any exchange sign-up button, referral link, or
 * "Connect your Swyftx account" control — not just in the footer.
 */
export const AffiliateDisclosure = ({
  className,
  partners = "Swyftx, CoinSpot and CoinJar",
}: AffiliateDisclosureProps) => (
  <p
    role="note"
    className={cn("text-xs text-muted-foreground leading-relaxed", className)}
  >
    <span className="font-medium text-foreground">Affiliate disclosure:</span>{" "}
    GoToCoins has affiliate relationships with {partners}. We may earn a commission if you
    sign up or trade through these links, at no extra cost to you. This does not influence our
    scores or research.{" "}
    <Link to="/disclaimer" className="underline underline-offset-2 hover:text-foreground">
      Full disclaimer
    </Link>
    .
  </p>
);

export default AffiliateDisclosure;
